/**
 * チェックボックスのオンオフとボタンの有効化の連動
 */

(function ($) {
  $.fn.extend({
    checkOnButton(options) {
      const o = $.extend(
        {
          buttonElement: '.c-form__submit',
          onClass: 'is-active',
          offClass: 'is-inactive',
        },
        options,
      );
      return this.each(function () {
        const $checkElement = $(this).find('input[type="checkbox"]');
        const $buttonElement = $(this).find(o.buttonElement);

        function checkStatus($this) {
          if ($this.prop('checked')) {
            $buttonElement
              .attr('disabled', false)
              .removeClass(o.offClass)
              .addClass(o.onClass);
          } else {
            $buttonElement
              .attr('disabled', true)
              .removeClass(o.onClass)
              .addClass(o.offClass);
          }
        }

        $buttonElement.attr('disabled', true);

        checkStatus($checkElement);

        $checkElement.on('click', function () {
          checkStatus($(this));
        });
      });
    },
  });
})(jQuery);
